import React from 'react';

import BenchlingConfig from 'BenchlingConfig';
import {AdvancedSettingsDropdown} from 'schemas/fields/AdvancedSettingsDropdown';
import {AdvancedSettingsIconProps, getUnitDropdownOption} from 'schemas/fields/AdvancedSettingsIconUtils';

export default function SchemaInterfaceFieldAdvancedSettingsIcon(
  props: AdvancedSettingsIconProps
): JSX.Element {
  const options = [];
  if (BenchlingConfig.SCHEMAS_ENABLE_INTERFACE_FIELD_UNITS) {
    options.push(getUnitDropdownOption(props));
  }
  return <AdvancedSettingsDropdown options={options} />;
}
